var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",class:{ 'nav-open': _vm.$sidebar.showSidebar }},[_c('notifications'),_c('side-bar',{attrs:{"background-color":_vm.sidebarBackground,"title":"Apolo"},scopedSlots:_vm._u([{key:"links",fn:function(props){return [(_vm.can_view_menu_dashboard)?_c('sidebar-item',{attrs:{"link":{
          name: 'Dashboard',
          icon: 'now-ui-icons business_chart-pie-36',
          path: '/dashboard',
        }}}):_vm._e(),(_vm.can_view_metrics)?_c('sidebar-item',{attrs:{"link":{
          name: 'Métricas',
          icon: 'now-ui-icons business_chart-bar-32',
          path: '/metrics',
        }}}):_vm._e(),(_vm.can_view_menu_dimensionar)?_c('sidebar-item',{attrs:{"link":{
          name: 'Dimensionar',
          icon: 'now-ui-icons shopping_basket',
          path: '/dimension',
        }}}):_vm._e(),(_vm.can_view_menu_orcamentos)?_c('sidebar-item',{attrs:{"link":{
          name: 'Orçamentos',
          icon: 'now-ui-icons education_paper',
          path: '/budgets',
        }}}):_vm._e(),(_vm.can_view_menu_pedidos)?_c('sidebar-item',{attrs:{"link":{
          name: 'Pedidos',
          icon: 'now-ui-icons shopping_box',
          path: '/orders',
        }}}):_vm._e(),(_vm.can_view_menu_stringsizer)?_c('sidebar-item',{attrs:{"link":{
          name: 'StringSizer',
          icon: 'now-ui-icons business_bulb-63',
          path: '/string-sizer',
        }}}):_vm._e(),(_vm.can_view_menu_cadastrar_cliente)?_c('sidebar-item',{attrs:{"link":{
          name: 'Cadastrar Cliente',
          icon: 'now-ui-icons users_single-02',
          path: '/register-client',
        }}}):_vm._e(),(!_vm.is_customer)?_c('sidebar-item',{attrs:{"link":{
          name: 'Configurações',
          icon: 'now-ui-icons ui-1_settings-gear-63',
        }}},[(_vm.can_view_menu_produtos)?_c('sidebar-item',{attrs:{"link":{
            name: 'Produtos',
            icon: 'now-ui-icons design_app',
            path: '/settings/products',
          }}}):_vm._e(),(_vm.can_view_menu_marcas)?_c('sidebar-item',{attrs:{"link":{
            name: 'Marcas',
            icon: 'now-ui-icons design_app',
            path: '/settings/brands',
          }}}):_vm._e(),(_vm.can_view_menu_usuarios)?_c('sidebar-item',{attrs:{"link":{
            name: 'Usuários',
            icon: 'now-ui-icons design_app',
            path: '/settings/users',
          }}}):_vm._e(),(_vm.can_view_menu_clientes)?_c('sidebar-item',{attrs:{"link":{
            name: 'Clientes',
            icon: 'now-ui-icons design_app',
            path: '/settings/customers',
          }}}):_vm._e(),(_vm.can_view_menu_cargos)?_c('sidebar-item',{attrs:{"link":{
            name: 'Cargos',
            icon: 'now-ui-icons design_app',
            path: '/settings/roles',
          }}}):_vm._e(),(_vm.can_view_menu_permissoes)?_c('sidebar-item',{attrs:{"link":{
            name: 'Permissões',
            icon: 'now-ui-icons design_app',
            path: '/settings/permissions',
          }}}):_vm._e(),(_vm.can_view_menu_frete)?_c('sidebar-item',{attrs:{"link":{
            name: 'Frete',
            icon: 'now-ui-icons design_app',
            path: '/shipping',
          }}}):_vm._e(),(_vm.can_view_menu_fornecedores)?_c('sidebar-item',{attrs:{"link":{
            name: 'Fornecedores',
            icon: 'now-ui-icons design_app',
            path: '/settings/providers',
          }}}):_vm._e(),(_vm.can_view_menu_banner)?_c('sidebar-item',{attrs:{"link":{
            name: 'Banner',
            icon: 'now-ui-icons design_app',
            path: '/settings/banner',
          }}}):_vm._e(),(_vm.is_admin)?_c('sidebar-item',{attrs:{"link":{
            name: 'Quadros de avisos',
            icon: 'now-ui-icons design_app',
            path: '/settings/message-board',
          }}}):_vm._e(),(_vm.can_view_menu_categorias)?_c('sidebar-item',{attrs:{"link":{
            name: 'Categorias de produtos',
            icon: 'now-ui-icons design_app',
            path: '/settings/product-categories',
          }}}):_vm._e()],1):_vm._e()]}}])}),_c('div',{staticClass:"main-panel"},[_c('top-navbar'),_c('router-view',{attrs:{"name":"header"}}),_c('div',{class:{ content: !_vm.$route.meta.hideContent },on:{"click":_vm.toggleSidebar}},[_c('zoom-center-transition',{attrs:{"duration":200,"mode":"out-in"}},[_c('router-view')],1)],1),(!_vm.$route.meta.hideFooter)?_c('content-footer'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }